import { TConvertKeys } from '../common';

export enum ESocketSendMessageType {
  NOTIFICATION_START = 'notification:start',
  NOTIFICATION_STOP = 'notification:stop',
  ON_DEMAND_START = 'on_demand:start',
  ON_DEMAND_STOP = 'on_demand:stop',
  FIREHOSE_START = 'firehose:start',
  FIREHOSE_STOP = 'firehose:stop',
  CHAT_START = 'chat:start',
  CHAT_STOP = 'chat:stop',
  WAITING_ROOM_START = 'waiting_room:start',
  WAITING_ROOM_STOP = 'waiting_room:stop',

  // CANARY EVENTS
  CANARY_START = 'canary:start',
  CANARY_STOP = 'canary:stop',
}

interface ISocketSendMessageTemplate<
  T extends ESocketSendMessageType,
  B extends object | undefined = ISocketSendMessageCommonBody,
> {
  type: T;
  body: B;
}

interface ISocketSendMessageCommonBody {
  institution_id: string;
}

// ***************SOCKET SEND MESSAGE CHAT***************
type TSocketSendMessageChatStart = ISocketSendMessageTemplate<
  ESocketSendMessageType.CHAT_START,
  ISocketSendMessageCommonBody & { chat_id: string }
>;

type TSocketSendMessageChatStop = ISocketSendMessageTemplate<
  ESocketSendMessageType.CHAT_STOP,
  ISocketSendMessageCommonBody & { chat_id: string }
>;
// ***************END SOCKET SEND MESSAGE CHAT***************

// ***************SOCKET SEND MESSAGE NOTIFICATION***************
type TSocketSendMessageNotificationStart =
  ISocketSendMessageTemplate<ESocketSendMessageType.NOTIFICATION_START>;

type TSocketSendMessageNotificationStop =
  ISocketSendMessageTemplate<ESocketSendMessageType.NOTIFICATION_STOP>;
// ***************END SOCKET SEND MESSAGE NOTIFICATION***************

type TSocketSendMessageFirehoseStart =
  ISocketSendMessageTemplate<ESocketSendMessageType.FIREHOSE_START>;

type TSocketSendMessageFirehoseStop =
  ISocketSendMessageTemplate<ESocketSendMessageType.FIREHOSE_STOP>;

// ***************SOCKET SEND MESSAGE ON_DEMAND***************

type TSocketSendMessageOnDemandStart =
  ISocketSendMessageTemplate<ESocketSendMessageType.ON_DEMAND_START>;

type TSocketSendMessageOnDemandStop =
  ISocketSendMessageTemplate<ESocketSendMessageType.ON_DEMAND_STOP>;

// ***************END SOCKET SEND MESSAGE ON_DEMAND***************

// ***************SOCKET SEND MESSAGE WAITING_ROOM***************

type TSocketSendMessageWaitingRoomStart = ISocketSendMessageTemplate<
  ESocketSendMessageType.WAITING_ROOM_START,
  ISocketSendMessageCommonBody & { waiting_room_id?: string }
>;

type TSocketSendMessageWaitingStop = ISocketSendMessageTemplate<
  ESocketSendMessageType.WAITING_ROOM_STOP,
  ISocketSendMessageCommonBody & { waiting_room_id?: string }
>;

// ***************END SOCKET SEND MESSAGE WAITING_ROOM***************

// ***************SOCKET SEND MESSAGE CANARY***************

type TSocketSendMessageCanaryStart = ISocketSendMessageTemplate<
  ESocketSendMessageType.CANARY_START,
  { appointment_id: string; institution_id: string }
>;

type TSocketSendMessageCanaryStop = ISocketSendMessageTemplate<
  ESocketSendMessageType.CANARY_STOP,
  undefined
>;

// ***************END SOCKET SEND MESSAGE CANARY***************

// Add other SocketSendMessage
type TSocketSendMessage =
  | TSocketSendMessageNotificationStart
  | TSocketSendMessageNotificationStop
  | TSocketSendMessageOnDemandStart
  | TSocketSendMessageOnDemandStop
  | TSocketSendMessageFirehoseStart
  | TSocketSendMessageFirehoseStop
  | TSocketSendMessageChatStart
  | TSocketSendMessageChatStop
  | TSocketSendMessageWaitingRoomStart
  | TSocketSendMessageWaitingStop
  | TSocketSendMessageCanaryStart
  | TSocketSendMessageCanaryStop;

export type TSocketSendMessageCamel = TConvertKeys<TSocketSendMessage>;
